import React from 'react';

export const ProPricingBanner: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto mt-10 mb-4">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6 flex items-center gap-6">
        <img
          src="/assets/Portrait_GE.png"
          alt="Guillaume Ebelmann"
          className="w-16 h-16 rounded-full object-cover flex-shrink-0 ring-2 ring-blue-200"
        />
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className="bg-blue-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
              Offre Pro uniquement
            </span>
          </div>
          <p className="text-sm text-gray-700 leading-relaxed">
            Votre abonnement Pro inclut une <strong>session de 30 minutes en visioconférence avec Guillaume Ebelmann</strong>, fondateur de DPEWizard et investisseur immobilier, pour démarrer efficacement et tirer le meilleur parti de l'outil dans votre contexte métier.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProPricingBanner;
